import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { leaveTo } from '@wundo/client/leaveTo.ts';
import { practiceDestination } from '@/lib/roleplayRedirects.ts';

export const Route = createFileRoute('/roleplay')({
  validateSearch: (search: Record<string, unknown>) => ({
    session: typeof search.session === 'string' ? search.session : undefined,
  }),
  component: RoleplayRedirectRoute,
});

function RoleplayRedirectRoute() {
  const { session } = Route.useSearch();

  return <RoleplayRedirect session={session} />;
}

/* Nothing to show: the page exists only to hand the visitor on. */
export function RoleplayRedirect({ session }: { session: string | undefined }) {
  useEffect(() => {
    leaveTo(practiceDestination(session));
  }, [session]);

  return null;
}
